export const currentLanguageSelector = state => state.lang;
